import {Dossier} from "./models";
import {mois} from "./data";

export const calculateDossierStats = (dossiers: Dossier[]) => {
  let result: { enCours: number, expertise: number, receptionne: number, montantTotal: number } = {
    enCours: (dossiers.length > 0) ? dossiers.filter((dossier) => dossier.statut.libelle === 'En traitement').length : 0,
    expertise: (dossiers.length > 0) ? dossiers.filter((dossier) => dossier.statut.libelle === 'Expertise').length : 0,
    receptionne: (dossiers.length > 0) ? dossiers.filter((dossier) => dossier.statut.libelle === 'Réceptionné').length : 0,
    montantTotal: (dossiers.length > 0) ? dossiers
      .map((dossier) => (dossier.montantEstime))
      .reduce((montant, currentValue) => montant + currentValue, 0) : 0
  }
  return result
}

export const getStatusColor = (statut: string): string => {
  switch (statut) {
    case 'En traitement':
      return 'bg-blue-100 text-blue-700';
    case 'En expertise':
      return 'bg-amber-100 text-amber-700';
    case 'Réceptionnés':
      return 'bg-green-100 text-green-700';
    case 'Clôturé':
      return 'bg-gray-100 text-gray-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export const getPartenaireColor = (statut: string): string => {
  switch (statut) {
    case 'En traitement':
      return 'bg-blue-100 text-blue-700';
    case 'En expertise':
      return 'bg-amber-100 text-amber-700';
    case 'Réceptionnés':
      return 'bg-green-100 text-green-700';
    case 'Clôturé':
      return 'bg-gray-100 text-gray-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export const getInitials = (name: string): string => name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

export const formatCurrency = (amount: number): string => new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
}).format(amount);

// export const formatNumber = (num: number): string => new Intl.NumberFormat('fr-FR').format(num);

export const formatDate = (date: string | null | undefined, withHour: boolean = false): string => {
  if (date === '' || date === null || date === undefined) return '';

  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return '';

  return parsedDate.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    ...(withHour && {
      hour: '2-digit',
      minute: '2-digit',
    }),
  });
}

export const getSourceReferencePrefix = (source: string | null | undefined): string => {
  if (source === '' || source === null || source === undefined) {
    return '';
  }

  return `${source.split(' ')[1].slice(0,3)}-`;
}

export const cn = (...classes: (string | boolean | undefined)[]): string => classes.filter(Boolean).join(' ');

export const generateEmailRecap = (dossier: Dossier): string => `
RÉCAPITULATIF DOSSIER
=====================
Référence: ${dossier.id}
Date: ${dossier.dateCreation}
Statut: ${dossier.statut}

VÉHICULE
--------
${dossier.vehicule.marque} ${dossier.vehicule.modele}
Immatriculation: ${dossier.vehicule.immatriculation}
Année: ${dossier.vehicule.annee || 'N/R'}
Kilométrage: ${dossier.vehicule.kilometrage ? dossier.vehicule.kilometrage : 'N/R'}
VIN: ${dossier.vehicule.vinDocument || 'N/R'}

ESTIMATION: ${formatCurrency(dossier.montantEstime)}
`.trim();

// Statistique

export const prepareMonth = (data, displayMinimal: boolean = false) => {
  let months = mois.map(data => data.code);
  if (displayMinimal) months = months.map(month => month[0]);
  return data.map((item) => months[item?.month - 1]);
};

export const prepareData = (data, column: string) => {
  return data.map((item) => item?.[column]);
};

export const sumArrayData = (data: number[]) => {
  if (data.length === 0) return 0;
  return Number((data.reduce((accumulator, currentValue) => accumulator + currentValue, 0)).toFixed(2))
};

export const roundNumber = (value: number) => {
  return value ? value?.toFixed(2) : 0;
}

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short'
  });
  const number = (typeof value === 'string' ? parseInt(value.replace(/\D/g, '')) : value)
  return formatter.format(number);
};

export const calculateMoyenne = (data: number[]) => {
  if (data.length === 0) return 0;
  const valideData = data?.filter((value) => value !== 0);
  return parseFloat(((sumArrayData(valideData) / valideData?.length)).toFixed(2)) || 0;
}